import PropTypes from 'prop-types';
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Logo from 'src/components/logo';
import Scrollbar from 'src/components/scrollbar';
import { usePathname } from 'src/routes/hooks';
import { NavSectionVertical } from 'src/components/nav-section';
import NavUpgrade from 'src/components/subscription/nav-upgrade';
import Support from 'src/components/userSetting/support';
// auth
import { useAuthContext } from 'src/auth/hooks';
// context
import { FormShareContext, ModificationContext, typeIDContext } from 'src/context/Context';
// Modal
import ModalResetPassWord from 'src/components/userSetting/modal/ModalResetPassWord';
import ModalAcivateAccount from 'src/components/userSetting/modal/ModalAcivateAccount';
//
import { NAV } from '../config-layout';
import { useNavData, useNavDataTrainees, useNavDataAdmin, useNavDataManager } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavVertical({ openNav, onCloseNav, userRole }) {
  
  const { user } = useAuthContext();

  const pathname = usePathname();

  const formUrl = useContext(typeIDContext);
  const share = useContext(FormShareContext);
  const modal = useContext(ModificationContext);

  const lgUp = useResponsive('up', 'lg');

  const navigate = useNavigate();

  const organization = useNavData();
  const manager = useNavDataManager();
  const trainee = useNavDataTrainees();
  const administrator = useNavDataAdmin();

  let navData = '';
  let orgMenu = false;

  switch(userRole)
  {
    case 'trainee': navData = trainee; break;
    case 'manager': navData = manager; orgMenu= true; break;
    case 'administrator': navData = administrator; break;
    default: navData = organization; orgMenu= true;
  }

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    const payment = sessionStorage.getItem('payment');
    const rawParams = localStorage.getItem('params');
    const params = rawParams ? JSON.parse(rawParams) : null;

    const resolvedFormUrl = params
      ? `/forms/${params.id}/filled/${params.participant}`
      : null;

    // ✅ Couvre undefined ET null
    if(formUrl.typeID == null && resolvedFormUrl !== null) {
      formUrl.updateTypeID(resolvedFormUrl);
    }

    if (user.firstconnexion === 1 && share.reloadModalShare === false) {
      if (user.role === 'trainee') {
        share.updateFormShare(true);
        share.updateReloadModalShare(true);
        return;
      }

      if (user.role === 'organization' && user.offreID !== null && payment === null) {
        const offreID = user.offreID;
        navigate(`/subscriptions/pricing`, { state: { offreID, returnTab: 'subscription' } });
        return;
      }
    }

    if (user.firstconnexion === 0 && user.role === 'trainee') {
      if (user.activation === 0 && share.reloadModalShare === false) {
        modal.updateModification(true);
        share.updateReloadModalShare(true);
        return;
      }

      if (user.activation === 1 && formUrl.typeID && String(user.id) === String(params?.traineeID)) {
        navigate(formUrl.typeID);
        formUrl.updateTypeID(null);
        localStorage.removeItem('params');
      }
    }

  }, [user]);


  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Logo sx={{ mt: 3, ml: 4, mb: 1 }} />

      <NavSectionVertical
        data={navData}
        config={{
          currentRole: user?.role || 'admin',
        }}
      />

      <Box sx={{ flexGrow: 1 }} />

      {orgMenu && 
        <>
          <NavUpgrade />
          <Support />
        </>
      }

    </Scrollbar>
  );

  return (
    <>
      <Box
        component="nav"
        sx={{
          flexShrink: { lg: 0 },
          width: { lg: NAV.W_VERTICAL },
        }}
      >
        <NavToggleButton />

        {lgUp ? (
          <Stack
            sx={{
              height: 1,
              position: 'fixed',
              width: NAV.W_VERTICAL,
              borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
            }}
          >
            {renderContent}
          </Stack>
        ) : (
          <Drawer
            open={openNav}
            onClose={onCloseNav}
            PaperProps={{
              sx: {
                width: NAV.W_VERTICAL,
              },
            }}
          >
            {renderContent}
          </Drawer>
        )}
      </Box>

      {
        user.role === 'trainee' &&
        <>
          <ModalResetPassWord user={user} width='sm'/>
          <ModalAcivateAccount user={user} width='sm'/>
        </>
      }
     
    </>
  );
}

NavVertical.propTypes = {
  userRole: PropTypes.string,
  onCloseNav: PropTypes.func,
  openNav: PropTypes.bool,
};
